/* eslint-disable max-lines */
/* eslint-disable complexity */
import {
  BookWidgetAirport,
  BookWidgetFields,
  TripTypeOptions
} from '@com-delta-idp/mnx-capability-flight-shop-ui';
import { SelectedRange } from '@com-delta-omnichannel/mach/lib/components/organisms/date-picker/models/date-picker.interfaces';
import { maxFlightCountForMc } from '../../../constants/common.constants';

export const tripTypeRulesOnChangeEval = (
  bookWidgetFields: BookWidgetFields
): BookWidgetFields => {
  let updatedBookWidgetFields = { ...bookWidgetFields };

  if (
    updatedBookWidgetFields.tripTypesField.selectedTripType ===
    TripTypeOptions.MULTI_CITY
  ) {
    const updatedAirports: BookWidgetAirport[] = [
      { ...updatedBookWidgetFields.airportsField.airports[0] }
    ];

    const { toAirportcode = '', toCity = '' } =
      updatedAirports[updatedAirports.length - 1];

    updatedAirports.push({
      fromAirportcode: toAirportcode,
      fromCity: toCity,
      toAirportcode: '',
      toCity: '',
      connectionAirport: '',
      connectionCity: ''
    });

    updatedBookWidgetFields = {
      ...updatedBookWidgetFields,
      airportsField: {
        ...updatedBookWidgetFields.airportsField,
        airports: updatedAirports,
        showAddFlightBtn: updatedAirports.length < maxFlightCountForMc,
        showRemoveFlightBtn: updatedAirports.length > 2
      }
    };

    const updatedDates: SelectedRange[] = [
      {
        start: bookWidgetFields.datesField.dates[0].start || null,
        end: null,
        total: 0
      },
      {
        start: bookWidgetFields.datesField.dates[0].start || null,
        end: null,
        total: 0
      }
    ];

    updatedBookWidgetFields = {
      ...updatedBookWidgetFields,
      datesField: {
        ...updatedBookWidgetFields.datesField,
        dates: updatedDates
      }
    };
  } else {
    const updatedAirports: BookWidgetAirport[] = [
      {
        ...updatedBookWidgetFields.airportsField.airports[0],
        connectionAirport: '',
        connectionCity: ''
      }
    ];

    updatedBookWidgetFields = {
      ...updatedBookWidgetFields,
      airportsField: {
        ...updatedBookWidgetFields.airportsField,
        airports: updatedAirports,
        showAddFlightBtn: false,
        showRemoveFlightBtn: false
      }
    };

    const updatedDates: SelectedRange[] = [
      {
        start: bookWidgetFields.datesField.dates[0].start || null,
        end: null,
        total: 0
      }
    ];

    updatedBookWidgetFields = {
      ...updatedBookWidgetFields,
      datesField: {
        ...updatedBookWidgetFields.datesField,
        dates: updatedDates
      }
    };
  }

  return updatedBookWidgetFields;
};
